import Vue from "vue";
import VueRouter from "vue-router";
import Homepc from "@/views/Home_PC.vue";
import Product from "@/views/Product/index.vue";
import Product1s from  "@/views/Product/Product_1.vue"
import Product2s from  "@/views/Product/Product_2.vue"
import Product3s from  "@/views/Product/Product_3.vue"
import Product4s from  "@/views/Product/Product_4.vue"
import Product5s from  "@/views/Product/Product_5.vue"
import Product6s from  "@/views/Product/Product_6.vue"
import Product7s from  "@/views/Product/Product_7.vue"
import Product8s from  "@/views/Product/Product_8.vue"
import AboutUs from "@/views/AboutUs/index.vue";
// import Privacy from "@/views/Privacy/index.vue";
Vue.use(VueRouter);

const router = new VueRouter({
  routes: [
    {
      path: "/",
      name:"home",
      component: Homepc,
    },
    {
      path: "/home",
      name:"home",
      component: Homepc,
    },
    {
      path: "/Product",
      name: "Product",
      component: Product,
    },
    {
      path: "/Product1s",
      name: "Product1s",
      component: Product1s,
    },
    {
      path: "/Product2s",
      name: "Product2s",
      component: Product2s,
    },
    {
      path: "/Product3s",
      name: "Product3s",
      component: Product3s,
    },
    {
      path: "/Product4s",
      name: "Product4s",
      component: Product4s,
    },
    {
      path: "/Product5s",
      name: "Product5s",
      component: Product5s,
    },
    {
      path: "/Product6s",
      name: "Product6s",
      component: Product6s,
    },
    {
      path: "/Product7s",
      name: "Product7s",
      component: Product7s,
    },
    {
      path: "/Product8s",
      name: "Product8s",
      component: Product8s,
    },
    {
      path: "/AboutUs",
      name: "AboutUs",
      component: AboutUs,
    },
    // {
    //   path: "/Privacy",
    //   name: "Privacy",
    //   component: Privacy,
    // }
  ],
});
// // 跳转之后重置界面大小
// router.afterEach((to, from) => {

// })
/** 解决跳转重复路由报错问题 */

const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};

export default router; // 将其暴漏  其他组件就可以导入router
